import http from "../../http";

export default {
  list(params) {
    return http.get("cmsservice/cms_case/page", params);
  },
  listall(params) {
    return http.get("cmsservice/cms_case/page/share", params);
  },
  info(id) {
    return http.get("cmsservice/cms_case/info/" + id, {});
  },
  add(params) {
    return http.post("cmsservice/cms_case/add", params);
  },
  update(params) {
    return http.post("cmsservice/cms_case/update", params);
  },
  //上架下架
  status(params) {
    return http.get("cmsservice/cms_case/status", params);
  },
  //置顶
  top(params) {
    return http.get("cmsservice/cms_case/top", params);
  },
  delete(params) {
    return http.post("cmsservice/cms_case/delete", params);
  },
  type: {
    tree(params) {
      return http.get("cmsservice/caseSort/tree", params);
    },
    add(params) {
      return http.post("cmsservice/caseSort/add", params);
    },
    update(params) {
      return http.put("cmsservice/caseSort/update", params);
    },
    delete(id) {
      return http.delete("cmsservice/caseSort/del/" + id, {});
    }
  },
  topic(params) {
    return http.get("cmsservice/cms_case/page/for/topic", params);
  },
};
